import { Dialogs, Toast } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import { Context } from '@leverege/plugin';
import { Attributes, DataSources } from '@leverege/ui-attributes';
import I18N from '@leverege/i18n';
import { Types } from "../../constants/index.js";
import FirmwareReleaseActionDialog from "../../views/firmwareReleaseAction/FirmwareReleaseActionDialog.js";
const {
  tIcon
} = I18N.ns('api-ui-fota-management.PauseAction');
export default {
  id: 'blueprint.action.fota.pauseFirmwareRelease',
  name: 'Pause Firmware Release',
  layout: {
    sort: 'firmwareRelease.pause'
  },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    objectType: Types.firmwareRelease
  }, {
    client: ['MapBoxRolloverSelectionPointer', 'ListDataViewer'],
    use: ['contextMenu'],
    objectType: Types.firmwareRelease
  }],
  isPrepared: cxt => {
    const {
      clientProps: {
        objectType
      }
    } = cxt;
    const target = Context.getTargetOfType(cxt, objectType);
    if (!target) {
      // nothing to do
      return true;
    }
    const delegate = DataSources.getDelegate(target);
    return delegate.canPause() != null;
  },
  prepare: cxt => {
    const {
      clientProps: {
        objectType
      }
    } = cxt;
    const target = Context.getTargetOfType(cxt, objectType);
    const delegate = DataSources.getDelegate(target);
    return GlobalState.dispatch(delegate.requestCanPause());
  },
  handles: cxt => {
    const target = Context.getTargetOfType(cxt, Types.firmwareRelease);
    if (!target || Attributes.get('state', Types.firmwareRelease, target?.data) !== 'active') {
      return false;
    }
    const delegate = DataSources.getDelegate(target);
    return delegate.canPause();
  },
  appearance: ({
    context
  }) => {
    const target = Context.getTargetOfType(context, Types.firmwareRelease);
    return {
      name: `Pause ${Attributes.get('name', Types.firmwareRelease, target?.data)}`,
      icon: tIcon('icon')
    };
  },
  perform: ({
    context
  }) => {
    const {
      reloadData
    } = context;
    const target = Context.getTargetOfType(context, Types.firmwareRelease);
    const delegate = DataSources.getDelegate(target);
    Dialogs.show({
      component: FirmwareReleaseActionDialog,
      props: {
        onSubmit: async () => {
          try {
            await GlobalState.dispatch(delegate.pause());
            Toast.success('Successfully paused firmware release.');
          } catch (err) {
            Toast.error(['Failed to pause firmware release.', err.message]);
          }
          reloadData();
        },
        actionName: 'Pause',
        target
      }
    });
  }
};